module.exports = __webpack_public_path__ + "img/replace-circle.8734c785.svg";